import { initializeApp, getApps, FirebaseApp } from "firebase/app";
import { getAuth, Auth } from "firebase/auth";
import { getFirestore, Firestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: process.env.GATSBY_FIREBASE_API_KEY!,
    authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN!,
    projectId: process.env.GATSBY_FIREBASE_PROJECT_ID!,
    storageBucket: process.env.GATSBY_FIREBASE_STORAGE_BUCKET!,
    messagingSenderId: process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID!,
    appId: process.env.GATSBY_FIREBASE_APP_ID!,
};

export const app: FirebaseApp =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

export const db: Firestore = getFirestore(app);

export const getFirebaseAuth = (): Auth => getAuth(app);